module.exports = __webpack_public_path__ + "img/801804a.png";